import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { ArrowRight } from 'lucide-react';
import { travelCollections } from '../data/mock';

export const CollectionsPage = () => {
  return (
    <div>
      <Navigation />
      <WhatsAppButton variant="floating" />

      {/* Hero Section */}
      <section style={{
        background: 'var(--bg-secondary)',
        padding: '120px 0 80px',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Our Signature Journeys
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Thoughtfully curated experiences designed around culture, discovery, connection, and the way you want to travel — across Indonesia and worldwide.
          </p>
        </div>
      </section>

      {/* Collections Grid */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '32px'
          }}>
            {travelCollections.map((collection) => {
              // Determine the appropriate route based on collection type
              let collectionRoute = '/contact';
              if (collection.id === 'mice-business') {
                collectionRoute = '/b2b';
              } else if (collection.id === 'cultural-heritage' || collection.id === 'coffee-culinary' || collection.id === 'art-design' || collection.id === 'adventure-nature' || collection.id === 'wellness-slow') {
                collectionRoute = '/indonesia-journeys';
              }
              
              return (
                <Link
                  key={collection.id}
                  to={collectionRoute}
                  style={{
                    background: 'var(--bg-primary)',
                    borderRadius: 0,
                    overflow: 'hidden',
                    textDecoration: 'none',
                    display: 'block',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                  }}
                  className="hover-lift"
                >
                  <div style={{
                    width: '100%',
                    height: '320px',
                    overflow: 'hidden'
                  }}>
                    <img
                      src={collection.image}
                      alt={collection.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                      onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                    />
                  </div>
                  <div style={{ padding: '24px' }}>
                    <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                      {collection.title}
                    </h3>
                    <p className="body-regular" style={{ 
                      color: 'var(--text-secondary)', 
                      marginBottom: '16px',
                      lineHeight: 1.6
                    }}>
                      {collection.description}
                    </p>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '8px',
                      color: 'var(--interactive-base)',
                      fontSize: '14px',
                      fontWeight: 400
                    }}>
                      {collection.id === 'mice-business' ? 'Explore MICE & Business' : 'Explore experiences'}
                      <ArrowRight size={16} />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
